import { render, staticRenderFns } from "./AgendaBlocksSection.vue?vue&type=template&id=2bb55aa6&scoped=true"
import script from "./AgendaBlocksSection.vue?vue&type=script&lang=js"
export * from "./AgendaBlocksSection.vue?vue&type=script&lang=js"
import style0 from "./AgendaBlocksSection.vue?vue&type=style&index=0&id=2bb55aa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb55aa6",
  null
  
)

export default component.exports